import React from 'react';
import { Score as FalconScore, ScoreSize } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useApplicationState } from '@utils/useApplicationState';
import { useTranslations } from '@utils/useTranslations';

interface Props {
  score: number;
  scoreDescription: string;
  reviewsCount: number;
  size?: ScoreSize;
  backgroundColor: string;
  textColor: string;
  onClick?: () => void;
}

export const Score = ({
  backgroundColor,
  textColor,
  score,
  scoreDescription,
  reviewsCount,
  size,
  onClick,
}: Props) => {
  const { translations } = useTranslations();
  const { territoryLocale } = useApplicationState();

  const formattedScore = score.toFixed(1).toString();
  const reviewsText = i18n('sale.reviews.label', [], translations);
  const subtext = `${reviewsCount.toLocaleString(territoryLocale)} ${reviewsText}`;

  return (
    <FalconScore
      score={formattedScore}
      text={scoreDescription}
      subtext={subtext}
      size={size}
      onSubtextClick={onClick}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};
